import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerPodModalComponent} from './worker-pod-modal';

export const WorkerPodModalModule: string = ng
    .module('worker-pod-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerPodModalComponent', WorkerPodModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-pod-modal/worker-pod-modal.module.ts